const HeartIcon = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    style={{ enableBackground: 'new 0 0 512 512' }} // тут можно и убрать, если не работает
    width="24"
    height="24"
  >
    <path
      style={{ fill: '#E70020' }}
      d="M491.468,250.784c-21.734,39.74-55.445,71.461-88.047,102.133
         c-5.748,5.409-11.167,10.507-16.566,15.686c-20.225,19.425-40.699,38.14-60.504,56.255
         c-19.675,17.975-40.009,36.57-59.964,55.735L256,490.571l-10.387-9.977
         c-19.955-19.165-40.289-37.76-59.964-55.735c-19.805-18.115-40.279-36.83-60.504-56.255
         c-5.399-5.179-10.817-10.277-16.566-15.686c-32.601-30.672-66.313-62.394-88.047-102.133
         C-7.57,199.397-6.791,142.342,22.662,94.225c36.54-59.664,87.457-72.511,123.737-72.791
         c30.972-0.24,61.604,8.658,88.617,25.693L256,60.274l21.024-13.167
         c26.973-17.016,57.635-25.873,88.577-25.673c36.28,0.28,87.197,13.127,123.737,72.791
         C518.791,142.342,519.571,199.397,491.468,250.784z"
    />
    <path
      style={{ fill: '#E70020' }}
      d="M491.468,250.784c-21.734,39.74-55.445,71.461-88.047,102.133
         c-5.748,5.409-11.167,10.507-16.566,15.686c-20.225,19.425-40.699,38.14-60.504,56.255
         c-19.675,17.975-40.009,36.57-59.964,55.735L256,490.571V60.274l21.024-13.167
         c26.973-17.016,57.635-25.873,88.577-25.673c36.28,0.28,87.197,13.127,123.737,72.791
         C518.791,142.342,519.571,199.397,491.468,250.784z"
    />
  </svg>
);
export default HeartIcon;